// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__3dZ2s","icon":"EnquiryForm_icon__xAjFv","heading":"EnquiryForm_heading__3ULnv","field":"EnquiryForm_field__5pvVR","error":"EnquiryForm_error__3axsg"};